import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeDeserializer'
})

export class TimeDeserializer implements PipeTransform {
  transform (timeSpan: string) {
    if (timeSpan) {
      const tokens = timeSpan.split(':');

      // should only be three tokens for hours, minutes, and seconds
      if (tokens !== null && tokens.length === 3) {
        const tokens2 = tokens[0].split('.');
        // the serializer put a day.hours format for the first token
        if (tokens2.length > 1) {
          tokens[0] = ((Number(tokens2[0]) * 24) + Number(tokens2[1])).toString();
        }
        timeSpan = ((Number(tokens[0]) * 60) + Number(tokens[1])).toString();
      }
    }
    return timeSpan;
  }
}
